// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Client from "../Client.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as RootProvider from "../RootProvider.bs.js";
import * as Client$1 from "@apollo/client";

function WildcardsProvider$GraphQl(Props) {
  var getGraphEndpoints = Props.getGraphEndpoints;
  var children = Props.children;
  var networkId = Belt_Option.mapWithDefault(RootProvider.useNetworkId(undefined), 1, (function (a) {
          return a;
        }));
  var client = React.useMemo((function () {
          return Client.instance(Curry._1(getGraphEndpoints, networkId));
        }), [
        getGraphEndpoints,
        networkId
      ]);
  return React.createElement(Client$1.ApolloProvider, {
              client: client,
              children: children
            });
}

var GraphQl = {
  make: WildcardsProvider$GraphQl
};

function WildcardsProvider(Props) {
  var getGraphEndpoints = Props.getGraphEndpoints;
  var children = Props.children;
  var stewardContractAddress = Props.stewardContractAddress;
  var stewardAbi = Props.stewardAbi;
  return React.createElement(RootProvider.make, {
              children: React.createElement(WildcardsProvider$GraphQl, {
                    getGraphEndpoints: getGraphEndpoints,
                    children: children
                  }),
              stewardContractAddress: stewardContractAddress,
              stewardAbi: stewardAbi
            });
}

var make = WildcardsProvider;

export {
  GraphQl ,
  make ,
  
}
/* react Not a pure module */
